import Vue from 'vue'

if (process.client) {
  // navigator.userAgentData not working right on Chrome in device simulator mode
  // const isMobile = navigator.userAgentData
  //   ? navigator.userAgentData.mobile
  //   : navigator.userAgent.includes('Mobi')

  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
  const isMobile = navigator.userAgent.includes('Mobi')
  Vue.prototype.$device = {
    isMobile,
    isDesktop: !isMobile,
  }
}
